import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'search-brandsofffairequeryclick-action_category_click';

/**
 * We want to record a click whenever the user escapes the recommended brands when searching from brands off Faire

The parameters are
1. Raw Query
2. Brand Name
3. Request ID
 */
export function trackSearchBrandsofffairequeryclickActionCategoryClick(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
